import { Auth } from '@supabase/auth-ui-react'
import { ThemeSupa } from '@supabase/auth-ui-shared'
import { supabase } from '@/lib/supabase'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function AuthPage() {
  // Enable email/password auth for E2E testing
  const allowEmailAuth = import.meta.env.VITE_ALLOW_EMAIL_AUTH === 'true'

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold">Brian 2</CardTitle>
          <CardDescription>
            {allowEmailAuth
              ? 'Sign in with your Google account or email'
              : 'Sign in with your Google account to get started'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Auth
            supabaseClient={supabase}
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: 'rgb(15 23 42)',
                    brandAccent: 'rgb(30 41 59)',
                  },
                },
              },
            }}
            providers={['google']}
            onlyThirdPartyProviders={!allowEmailAuth}
            redirectTo={window.location.origin}
          />
        </CardContent>
      </Card>
    </div>
  )
}
